angular.module( 'acme.view.application.resources.requests', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.view.application.resources.requests.controllers',
  'acme.view.application.resources.requests.removeModal.controllers',
  'acme.view.application.resources.modals.assign.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesRequests = {
        name: 'application.resources.requests',
        url: '/requests?search&resourceStartTime&resourceEndTime',
        views: {
          "subview-main": {
            controller: 'ResourcesRequestsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/resources/requests/requests.tpl.html'
          }
        },
        data: {
          pageTitle: 'Assignments',
          pageClass: 'application application-resource-requests',
          permissions: ['RESOURCES_REQUESTS_VIEW'],
          enablePreferences: true
        },
        resolve: {
          customFields: ['ApiService', function (ApiService) {
            return ApiService.customFields.list();
          }]
        }
      };

    $stateProvider
      .state(resourcesRequests);
});
